// extracted by mini-css-extract-plugin
export var back = "workdetail-module--back--t3MC3";
export var backContainer = "workdetail-module--backContainer--TWERB";
export var line = "workdetail-module--line--TbukG";
export var link = "workdetail-module--link--n8VNV";